import AbsSidebar from "./AbsSidebar";

class SidebarSkill extends AbsSidebar{
    constructor(_store={}, _router={}, _el=''){
        super('class Sidebar', _store, _router, _el);
        this.store.dispatch( this.actions.loadTypes() );
    }

    addEvents(){
        super.addEvents();
        $( this.el + ' .gd-btn-refresh-condition').on('click', (e)=>{
            // this.store.dispatch( this.actions.setStopListLoad(true) );
            // this.store.dispatch( this.actions.setListpage( 1 ) );
            this.router.goMultiParamSetListPage( {
                'typesoper': '',
                'type': '',
                'lvmin': '',
                'lvmax': '',
                'raceid': '',
                'classid': ''
            });
            // this.store.dispatch( this.actions.setStopListLoad(false) );
            // this.store.dispatch( this.actions.loadItemList(1) );
        });
    }

} // end of class
export default SidebarSkill;